import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import VisibilityGroup from "../../../../groups/VisibilityGroup";

class MetricOpportunityCount extends MetricBase {
    constructor() {
        super({
            field: "metric_opportunities",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.opportunityCount.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.opportunityCount.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.opportunityCount.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricOpportunityCount;
